import { UPDATE_USER_NOTES } from '../../GlobalStateContainer';

export function userNotes(userNotes) {
    return { type: UPDATE_USER_NOTES, userNotes };
}